import { useEffect } from "react";
import Auth from "../Auth";

/**
 * Redirects to the user's default permitted page if they lack the required permission.
 * No-op for store_owner (they have all permissions).
 */
export default function usePermissionGuard(permission) {
  useEffect(() => {
    if (!Auth.isAuthenticated()) return;
    if (!Auth.hasPermission(permission)) {
      const fallback = Auth.defaultStorePath();
      window.location.replace(fallback);
    }
  }, [permission]);
}
